import { Button, Modal } from 'antd'
import { daemonDownloadLinks, detectDaemonDownloadUrl } from './store/daemonCompatibility'

// A single platform-appropriate download button when the OS is detectable,
// otherwise explicit links to both platform binaries (never guess).
export function DaemonDownloadControl() {
    const detected = detectDaemonDownloadUrl()

    if (detected) {
        return <Button type="primary" href={detected.href}>Скачать для {detected.label}</Button>
    }

    return (
        <span>
            {daemonDownloadLinks().map(link => (
                <Button key={link.key} href={link.href} style={{ marginRight: 8 }}>
                    Скачать для {link.label}
                </Button>
            ))}
        </span>
    )
}

export function DaemonBlockBanner({ daemonApi }) {
    return (
        <div role="alert"
            style={{ border: '1px solid #ff4d4f', background: '#fff2f0', color: '#cf1322', padding: 12, marginTop: 16, borderRadius: 4 }}>
            <p style={{ margin: 0, fontWeight: 600 }}>
                {daemonApi != null
                    ? `Версия API локального сервиса (${daemonApi}) не поддерживается приложением.`
                    : 'Версия локального сервиса не поддерживается.'}
            </p>
            <p style={{ margin: '4px 0 0 0' }}>Скачайте и запустите актуальный локальный сервис, чтобы тренироваться:</p>
            <div style={{ marginTop: 8 }}>
                <DaemonDownloadControl />
            </div>
        </div>
    )
}

export function showDaemonBlockModal(verdict) {
    Modal.error({
        title: 'Локальный сервис не поддерживается',
        content: (
            <div>
                <p>{verdict ? verdict.message : ''}</p>
                <div style={{ marginTop: 8 }}>
                    <DaemonDownloadControl />
                </div>
            </div>
        ),
        okText: 'Закрыть',
    })
}